"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const errorPageDefaultProps_1 = __importDefault(require("./errorPageDefaultProps"));
const Container = styled_components_1.default.div(({ fontFamily }) => ({
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    fontFamily: `${fontFamily}, sans-serif;`,
}));
const Logo = styled_components_1.default.img({
    width: "10%",
    height: "auto",
    position: "absolute",
    top: 32,
    left: "50%",
    transform: "translateX(-50%)",
    minWidth: 160,
});
const Title = styled_components_1.default.div(({ color }) => ({
    color,
    fontSize: 36,
    fontWeight: "700",
    marginBottom: 24,
}));
const Message = styled_components_1.default.div(({ color }) => ({
    fontSize: 21,
    lineHeight: "40px",
    maxWidth: 540,
    width: "100%",
    margin: "0 auto 32px",
    color,
}));
const Button = styled_components_1.default.button(({ fontFamily, borderWidth, color, borderColor, backgroundColor }) => ({
    fontFamily: `${fontFamily}, sans-serif;`,
    fontWeight: 700,
    fontSize: 16,
    height: "48px",
    width: "320px",
    maxWidth: "90%",
    borderWidth,
    borderColor,
    borderStyle: "solid",
    backgroundColor,
    color,
    cursor: "pointer",
    transition: "filter ease 100ms",
    "&:hover": {
        filter: "brightness(85%)",
    },
}));
const ErrorPage = ({ classes, message, messageColor, logo, title, titleColor, buttonLabel, fontFamily, buttonBackgroundColor, buttonLabelColor, buttonBorderWidth, buttonBorderColor, onClick, }) => {
    return (react_1.default.createElement(Container, { fontFamily: fontFamily },
        react_1.default.createElement(Logo, { className: classes === null || classes === void 0 ? void 0 : classes.logo, src: logo, alt: "logo" }),
        react_1.default.createElement("div", null,
            react_1.default.createElement(Title, { className: classes === null || classes === void 0 ? void 0 : classes.title, color: titleColor, "data-testid": "ui-generic-error-page-title" }, title),
            react_1.default.createElement(Message, { className: classes === null || classes === void 0 ? void 0 : classes.message, color: messageColor, "data-testid": "ui-generic-error-page-message" }, message),
            react_1.default.createElement(Button, { className: classes === null || classes === void 0 ? void 0 : classes.button, fontFamily: fontFamily, backgroundColor: buttonBackgroundColor, color: buttonLabelColor, borderWidth: buttonBorderWidth, borderColor: buttonBorderColor, onClick: onClick, "data-testid": "ui-generic-error-page-button" }, buttonLabel))));
};
exports.default = ErrorPage;
ErrorPage.defaultProps = errorPageDefaultProps_1.default;
